export default __webpack_public_path__ + "static/media/logo_sm_white.636e25dd.svg";